// src\app\routes.module.ts
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppConstants } from './constants/app-constants';
import { AuthGuardService } from './services/authguard/auth-guard.service';
import { CustomerPageComponent } from './page/customer-page/customer-page.component';
import { LoginPageComponent } from './page/login-page/login-page.component';
import { SignupPageComponent } from './page/signup-page/signup-page.component';
import { HomePageComponent } from './page/home-page/home-page.component';
import { TosGuardService } from './services/authguard/tos-guard.service';

import {
  ApplicationsAndInvitesPageComponent
} from "./page/applications-and-invites-page/applications-and-invites-page.component";
import { ForgotPasswordPageComponent } from './page/forgot-password-page/forgot-password-page.component';
import { ChangePasswordPageComponent } from './page/change-password-page/change-password-page.component';
import { TosPageComponent } from './page/tos-page/tos-page.component';
import { PeoplePageComponent } from './page/people-page/people-page.component';
import { SupplierTransactionPageComponent } from './page/supplier-transaction-page/supplier-transaction-page.component';
import { BorrowerTransactionPageComponent } from './page/borrower-transaction-page/borrower-transaction-page.component';
import { BorrowerRequestPageComponent } from './page/borrower-request-page/borrower-request-page.component';
import { TransactionDetailsComponent } from './components/transaction-details/transaction-details.component';

const routes: Routes = [
  { path: '', redirectTo: AppConstants.MENU_APPLICATIONS_INVITES, pathMatch: 'full' },

  /** Both flows */
  { path: AppConstants.MENU_LOGIN, component: LoginPageComponent },
  { path: AppConstants.MENU_FORGOT_PASSWORD_REQUEST, component: ForgotPasswordPageComponent },
  { path: `${AppConstants.MENU_CHANGE_PASSWORD}/:guid`, component: ChangePasswordPageComponent },
  { path: `${AppConstants.MENU_SIGNUP}/:signupGuid`, component: SignupPageComponent },
  { path: AppConstants.MENU_TOS, component: TosPageComponent, canActivate: [AuthGuardService] },
  { path: AppConstants.MENU_PEOPLE, component: PeoplePageComponent, canActivate: [AuthGuardService, TosGuardService] },

  /** Supplier */
  { path: AppConstants.MENU_APPLICATIONS_INVITES, component: ApplicationsAndInvitesPageComponent, canActivate: [AuthGuardService, TosGuardService] },
  { path: AppConstants.MENU_CUSTOMERS, component: CustomerPageComponent, canActivate: [AuthGuardService, TosGuardService] },
  { path: AppConstants.MENU_SUPPLIER_TRANSACTIONS, component: SupplierTransactionPageComponent, canActivate: [AuthGuardService, TosGuardService] },

  /** Borrower */
  { path: AppConstants.MENU_HOME, component: HomePageComponent, canActivate: [AuthGuardService, TosGuardService] },
  { path: AppConstants.MENU_BORROWER_TRANSACTIONS, component: BorrowerTransactionPageComponent, canActivate: [AuthGuardService, TosGuardService] },
  { path: AppConstants.MENU_REQUESTS, component: BorrowerRequestPageComponent, canActivate: [AuthGuardService, TosGuardService] },
  
  /** Transaction Details */
  { path: `${AppConstants.MENU_TRANSACTION_DETAILS}/:id`, component: TransactionDetailsComponent, canActivate: [AuthGuardService, TosGuardService] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutesModule { }
